import { RANGE_OPTIONS } from "@/lib/leadsFilter";

const TimeRangeFilter = ({ value, onChange, testId = "leads-range-filter" }) => {
  return (
    <div
      data-testid={testId}
      className="inline-flex flex-wrap items-center gap-1 rounded-full bg-neutral-100 p-1"
    >
      {RANGE_OPTIONS.map((r) => {
        const active = r.key === value;
        return (
          <button
            key={r.key}
            type="button"
            onClick={() => onChange(r.key)}
            data-testid={`${testId}-${r.key}`}
            data-active={active}
            className={`px-3 py-1.5 text-xs font-medium rounded-full transition-all ${
              active
                ? "bg-neutral-950 text-white shadow-sm"
                : "text-neutral-600 hover:text-neutral-900"
            }`}
          >
            {r.label}
          </button>
        );
      })}
    </div>
  );
};

export default TimeRangeFilter;
